import { ApiContext } from '../../types'
import getCurrentBearerToken from '../authentication/getCurrentBearerToken'

export default async function getBatchPayouts(
  { client, config }: ApiContext,
  numbers: string,
): Promise<any> {
  try {
    const token = await getCurrentBearerToken({
      client,
      config,
    })

    const response = await client.payouts.batchPayouts(
      { bearerToken: token },
      { payout_numbers: numbers },
    )
    if (response.isSuccess()) {
      return response.success()
    } else {
      throw response.fail()
    }
  } catch (e) {
    console.error(e)
    throw e
  }
}
